/**
 * The below file contains the actions used in the Camp Inmates Registration.
 * @author: vishal.mishra@velsof.com
 * @date :11-10-2023
 */

import {
  CAMP_INMATES_REGISTRATION_IMPORT,
  GET_ALL_CREATE_LANDSLIDE_INMATES_REGISTRATION,
  GET_ALL_LANDSLIDE_INMATES_REGISTRATION,
  GET_ALL_UPDATE_LANDSLIDE_INMATES_REGISTRATION,
  GET_EXPORT_CAMP_INMATES_DATA,
  GET_IMPORT_TEMPLATE_CAMP_INMATES_DATA,
  SET_ALL_CREATE_LANDSLIDE_INMATES_REGISTRATION,
  SET_ALL_LANDSLIDE_INMATES_REGISTRATION,
  SET_ALL_UPDATE_LANDSLIDE_INMATES_REGISTRATION,
  SET_EXPORT_CAMP_INMATES_DATA,
  SET_LANDSLIDE_INMATES_REGISTRATION,
  SET_IMPORT_TEMPLATE_CAMP_INMATES_DATA,
  CAMP_INMATES_REGISTRATION_IMPORT_EXCEL,
} from "redux/constants/LandslideInmatesRegistration";

// Import the constants you defined

// Action to fetch the Camp Inmates Registration
export const landslideGetAllInmatesRegistration = (data) => {
  return {
    type: GET_ALL_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
  };
};

// Action to fetch a new Camp Inmates Registration
export const landslideSetAllInmatesRegistration = (data) => {
  return {
    type: SET_ALL_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
  };
};

// Action to fetch the Camp Inmates Registration
export const landslideGetAllCreateInmatesRegistration = (data) => {
  return {
    type: GET_ALL_CREATE_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
  };
};

// Action to fetch a new Camp Inmates Registration
export const landslideSetAllCreateInmatesRegistration = (data) => {
  return {
    type: SET_ALL_CREATE_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
  };
};

// Action to fetch the Camp Inmates Registration
export const landslideGetAllUpdateInmatesRegistration = (data, id) => {
  return {
    type: GET_ALL_UPDATE_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
    id: id,
  };
};

// Action to fetch a new Camp Inmates Registration
export const landslideSetAllUpdateInmatesRegistration = (data) => {
  return {
    type: SET_ALL_UPDATE_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
  };
};

/**
 * Method for setting the Landslide Inmates Registration parameters
 * @param {any} data Landslide Data
 * @returns Json Object
 */
export const landslideSetInmatesRegistrationTableParam = (data) => {
  return {
    type: SET_LANDSLIDE_INMATES_REGISTRATION,
    payload: data,
  };
};

/**
 * Method for Camp Inmates Registration import
 * @param {any} data Camp Inmates Registration Data
 * @returns Json Object
 */
export const landslideCampInmatesRegistrationImport = (data) => {
  return {
    type: CAMP_INMATES_REGISTRATION_IMPORT,
    payload: data,
  };
};

/**
 * Method for Non Camp Inmates Registration import excel
 * @param {any} data Camp Inmates Registration Data
 * @returns Json Object
 */
export const landslideCampInmatesRegistrationImportExcel = (data) => {
  return {
    type: CAMP_INMATES_REGISTRATION_IMPORT_EXCEL,
    payload: data,
  };
};

/**
 * Method for getting the export file of Camp Inmates Registration
 * @returns Json Object
 */
export const landslideGetExportInmatesRegistration = (data) => {
  return {
    type: GET_EXPORT_CAMP_INMATES_DATA,
    payload: data,
  };
};

/**
 * Method for setting the reliefCamp export data in the state
 * @param {any} data Relief Camp Data
 * @returns Json Object
 */
export const landslideSetExportInmatesRegistration = (data) => {
  return {
    type: SET_EXPORT_CAMP_INMATES_DATA,
    payload: data,
  };
};
/**
 * Method for getting the import template of Camp Inmates Registration
 * @returns Json Object
 */
export const landslideGetImportTemplateInmatesRegistration = (data) => {
  return {
    type: GET_IMPORT_TEMPLATE_CAMP_INMATES_DATA,
    payload: data,
  };
};

/**
 * Method for setting the import template data in the state
 * @param {any} data Relief Camp Data
 * @returns Json Object
 */
export const landslideSetImportTemplateInmatesRegistration = (data) => {
  return {
    type: SET_IMPORT_TEMPLATE_CAMP_INMATES_DATA,
    payload: data,
  };
};
